export default "/_next/static/casts/faster-file-2.fb6612ae994028de3cbc82f31e257e92.cast";